import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface NewWindowButtonProps {
  clientId?: string;
}

export const NewWindowButton: React.FC<NewWindowButtonProps> = props => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('clientLng');

  const handleClick = () => {
    if (props.clientId) {
      nav.clientEditor(props.clientId, true);
    }
  };

  return (
    <OverlayTrigger overlay={<Tooltip>{t(tk.common.openNewCard)}</Tooltip>}>
      <Button
        onClick={e => {
          e.stopPropagation();
          handleClick();
        }}
        variant="btn-info"
        className="px-2"
      >
        <Icon.BoxArrowUpRight className="icon-blue" size={16} />
      </Button>
    </OverlayTrigger>
  );
};
